module.exports = __webpack_public_path__ + "static/media/bise.e602ff9d.svg";